import Cookies from "js-cookie"

const normalize = (value) => value?.replace(/\+/g, " ")

export const pop = (key, callback) => {
  const value = Cookies.get(key)
  callback(normalize(value))
  Cookies.remove(key)
}
